// Officer notebook — the 12 cells from meta/compliance/global.yaml
// render as horizontal tabs. The active cell is driven by `?cell=`
// in the URL so an officer can deep-link / share a tab.
//
// officerId is `global` for v7 — the metagraph defines a single
// global compliance officer. Phase 6+ may introduce per-officer
// dossiers, at which point this becomes a route param.

import { useSearchParams } from 'react-router-dom';
import { CELLS, defaultCellName, findCell } from '../lib/cell-registry';
import { CELL_COMPONENTS } from '../components/cells';

const OFFICER_ID = 'global';

export function Officer() {
  const [params, setParams] = useSearchParams();
  const cellName = params.get('cell') ?? defaultCellName;
  const active = findCell(cellName);
  const ActiveCell = CELL_COMPONENTS[cellName];

  return (
    <div className="space-y-4">
      <header>
        <h2 className="text-2xl font-semibold text-foreground">Compliance officer</h2>
        <p className="mt-1 text-foreground-mute text-sm">
          12 surfaces from <code>meta/compliance/global.yaml</code>.
        </p>
      </header>

      <div className="overflow-x-auto -mx-6 px-6 border-b border-border-soft">
        <div className="flex gap-1">
          {CELLS.map((c) => (
            <button
              key={c.name}
              onClick={() =>
                setParams((next) => {
                  next.set('cell', c.name);
                  return next;
                })
              }
              className={`whitespace-nowrap px-3 py-2 text-sm rounded-t-md border-b-2 transition-colors ${
                c.name === cellName
                  ? 'border-primary text-primary bg-primary-soft'
                  : 'border-transparent text-foreground-mute hover:text-foreground hover:bg-muted'
              }`}
            >
              {c.title}
            </button>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-border-soft bg-card p-6">
        {!active || !ActiveCell ? (
          <div className="text-foreground-mute">Unknown cell: {cellName}</div>
        ) : (
          <ActiveCell officerId={OFFICER_ID} />
        )}
      </div>
    </div>
  );
}
